<template>
  <div class="blob-outer-container">
    <div class="blob-inner-container">
        <div class="blob"></div>
    </div>
  </div>

  <router-view/>
</template>

<script>
export default {
  components: {
  }
}
</script>
<style>
@import url('./style.css')
</style>
